var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":"","permanent":"","clipped":"","width":"350"}},[_c('InputBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }